import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import ListItemIcon from '@mui/material/ListItemIcon';
import SvgIcon from '@mui/material/SvgIcon';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { translations } from '../../../utils/staticContent';
import { ColorMode } from './useColorMode';

function ToggleColorMode({ mode }: { mode: ColorMode }) {
    return (
        <>
            <ListItemIcon>{mode === 'light' ? <LightModeIcon /> : <DarkModeIcon />}</ListItemIcon>
            <ToggleButtonGroup color="primary" value={mode} exclusive aria-label="Color theme">
                <ToggleButton
                    size="small"
                    value="light"
                    sx={{ paddingLeft: 1.5, paddingRight: 1.5 }}
                >
                    <SvgIcon fontSize="small" sx={{ marginRight: '8px' }}>
                        <LightModeIcon />
                    </SvgIcon>
                    {translations.light}
                </ToggleButton>
                <ToggleButton
                    size="small"
                    value="dark"
                    sx={{ paddingLeft: 1.5, paddingRight: 1.5 }}
                >
                    <SvgIcon fontSize="small" sx={{ marginRight: '8px' }}>
                        <DarkModeIcon />
                    </SvgIcon>
                    {translations.dark}
                </ToggleButton>
            </ToggleButtonGroup>
        </>
    );
}

export default ToggleColorMode;
